/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import { useAppSelector } from "../../../../infra/hooks";
import DTOPayHistory from "./DTOPayHistory";
import PayHistoryPresenter from "./PayHistoryPresenter";
import { useTranslation } from "react-i18next";
function PayHistoryController() {
  const { t } = useTranslation();
  const [payHistoryData, setPayHistoryData] = useState([]);
  const [yearFilter, setYearFilter] = useState<number>(0);
  const [currency, setCurrency] = useState("");

  const isLoading = useAppSelector(
    (state) => state.salaryLoadersSlice.payHistoryLoader
  );
  
  function callBackFunc(data: any) {
    setPayHistoryData(data);
  }

  const getYearFilter = (year: number) => {
    setYearFilter(year);
  };
  const getCurrency = (currency: any) => {
    setCurrency(currency);
  };

  return (
    <div>
      <DTOPayHistory
        setCurrency={getCurrency}
        setPayHistoryData={callBackFunc}
        yearFilter={yearFilter}
      />
      <PayHistoryPresenter
        payHistoryData={payHistoryData}
        setFilterYear={getYearFilter}
        currency={currency}
        isLoading={isLoading}
        trans={t}
      />
    </div>
  );
}

export default PayHistoryController;
